module.exports = __webpack_public_path__ + "img/threads.191923d3.svg";